import { lazy } from 'react';

const FormList = lazy(() => import('./FormList'));

export { FormList };
